import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import ecommerceSaga from "./e-commerce/saga"
import calendarSaga from "./calendar/saga"
import chatSaga from "./chat/saga"
import cryptoSaga from "./crypto/saga"
import invoiceSaga from "./invoices/saga"
import projectsSaga from "./projects/saga"
import tasksSaga from "./tasks/saga"
import mailsSaga from "./mails/saga"
import contactsSaga from "./contacts/saga";
import dashboardSaga from "./dashboard/saga";
import dashboardSaasSaga from "./dashboard-saas/saga";
import holidaySaga from "./master/holiday/saga"
import rolesSaga from "./master/role/saga"
import loginCreationSaga from "./configuration/logincreation/saga"
import categoryMasterSaga from "./master/category/saga"
import unitMasterSaga from "./master/unit/saga"
import leaveSaga from "./master/leave/saga"
import departmentSaga from "./master/department/saga"
import designationSaga from "./master/designation/saga"
import shiftSaga from "./master/shift/saga"
import shiftGroupSaga from "./master/shiftgroup/saga"
import qualificationSaga from "./master/qualification/saga"
import employeeDetailsSaga from "./employee/employeedetails/saga"
import employeeExemptionSaga from "./employee/exemption/saga"
import employeeResignationSaga from "./employee/resignation/saga"
import employeeCircularSaga from "./employee/circular/saga"
import employeePermissionPolicySaga from "./employee/permission-policy/saga"
import employeeMultiLevelSaga from "./employee/multilevel-approval/saga"
import recruitmentKeysRespSaga from "./recruitment/keys-responsibilities/saga"
import recruitmentQualiSaga from "./recruitment/qualification/saga"
import empGracePolicySaga from "./employee/grace-policy/saga"
import reimbursementMasterSaga from "./reimbursement/master/saga"
import reimbursementReportsSaga from "./reimbursement/Reports/saga"
import payrollSetupAllowanceSaga from "./payroll/setup/allowance/saga"
import categoryMappingSaga from "./payroll/setup/mapping/saga"
import payrollSetupDeductionSaga from "./payroll/setup/deduction/saga"
import reimbursementClaimSaga from "./reimbursement/transactions/saga"
import payrollSetupSalaryScaleSaga from "./payroll/setup/salary-scale/saga"
import payrollDeductionTaxSaga from "./payroll/deduction/tax/saga"
import payrollDeductionFixedDeductionSaga from "./payroll/deduction/fixed-deduction/saga"
import jobSetupPositionSkillSaga from "./recruitment/position/saga"
import attendanceTimeDeductionSaga from "./attendance/time-deductions/saga"
import payrollDeductionMonthlyDeductionSaga from "./payroll/deduction/monthly-deduction/saga"
import timesheetSetupServiceSaga from "./timesheet/setup/service/saga"
import timesheetSetupClientSaga from "./timesheet/setup/client/saga"
import timesheetSetupProjectSaga from "./timesheet/setup/project/saga"
import timesheetSetupModuleSaga from "./timesheet/setup/module/saga"
import timesheetSetupTaskSaga from "./timesheet/setup/task/saga"
import timesheetSetupTaskTypeSaga from "./timesheet/setup/task-type/saga"
import payrollSalaryEmployeeSalaryDefinitionSaga from "./payroll/salary/salary-definition/saga"
import attendanceBiometricSaga from "./attendance/biometric/saga"
import payrollSalaryExtraPaymentSaga from "./payroll/salary/extra-payment/saga"
import payrollSalaryAllowanceSaga from "./payroll/salary/allowance/saga"
import payrollSalaryStopPaymentSaga from "./payroll/salary/stoppayment/saga"
import recruitmentRequistionSaga from "./recruitment/requistion/saga"
import timesheetTransactionApplySaga from "./timesheet/transactions/apply/saga"
import timesheetTransactionApprovalSaga from "./timesheet/transactions/approval/saga"
import timesheetReportsSaga from "./timesheet/reports/saga"
import expensesMasterSaga from "./expenses/saga"
import recruitmentOnboardingSaga from "./recruitment/onboarding/saga"
import attendanceExtraDutySaga from "./attendance/extra-duty/saga"
import attendanceLeaveManagSaga from "./attendance/leave/saga"
import employeeReportSaga from "./report/employee/saga"
import attendanceReportSaga from "./report/attendance/saga"
import skillMasterSaga from "./master/skill/saga"
import resourceApprovalSaga from "./recruitment/resource-approval/saga"
import tripmasterSaga from "./master/tripmaster/saga"
import PayrollReportsSaga from "./payroll/reports/saga"
import bankMasterSaga from "./master/bank/saga"
import evaluationMasterSaga from "./master/evaluation/saga"
import scoreMasterSaga from "./master/score/saga"


export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(ecommerceSaga),
    fork(calendarSaga),
    fork(chatSaga),
    fork(mailsSaga),
    fork(cryptoSaga),
    fork(invoiceSaga),
    fork(projectsSaga),
    fork(tasksSaga),
    fork(contactsSaga),
    fork(dashboardSaga),
    fork(dashboardSaasSaga),
    fork(holidaySaga),
    fork(rolesSaga),
    fork(loginCreationSaga),
    fork(categoryMasterSaga),
    fork(unitMasterSaga),
    fork(leaveSaga),
    fork(departmentSaga),
    fork(designationSaga),
    fork(shiftSaga),
    fork(shiftGroupSaga),
    fork(qualificationSaga),
    fork(employeeDetailsSaga),
    fork(employeeExemptionSaga),
    fork(employeeResignationSaga),
    fork(employeeCircularSaga),
    fork(employeePermissionPolicySaga),
    fork(employeeMultiLevelSaga),
    fork(recruitmentKeysRespSaga),
    fork(recruitmentQualiSaga),
    fork(empGracePolicySaga),
    fork(reimbursementMasterSaga),
    fork(reimbursementReportsSaga),
    fork(payrollSetupAllowanceSaga),
    fork(categoryMappingSaga),
    fork(payrollSetupDeductionSaga),
    fork(reimbursementClaimSaga),
    fork(payrollSetupSalaryScaleSaga),
    fork(payrollDeductionTaxSaga),
    fork(payrollDeductionFixedDeductionSaga),
    fork(jobSetupPositionSkillSaga),
    fork(attendanceTimeDeductionSaga),
    fork(payrollDeductionMonthlyDeductionSaga),
    fork(timesheetSetupServiceSaga),
    fork(timesheetSetupClientSaga),
    fork(timesheetSetupProjectSaga),
    fork(timesheetSetupModuleSaga),
    fork(timesheetSetupTaskSaga),
    fork(timesheetSetupTaskTypeSaga),
    fork(payrollSalaryEmployeeSalaryDefinitionSaga),
    fork(attendanceBiometricSaga),
    fork(payrollSalaryExtraPaymentSaga),
    fork(payrollSalaryAllowanceSaga),
    fork(payrollSalaryStopPaymentSaga),
    fork(recruitmentRequistionSaga),
    fork(timesheetTransactionApplySaga),
    fork(timesheetTransactionApprovalSaga),
    fork(timesheetReportsSaga),
    fork(expensesMasterSaga),
    fork(recruitmentOnboardingSaga),
    fork(attendanceExtraDutySaga),
    fork(attendanceLeaveManagSaga),
    fork(employeeReportSaga),
    fork(attendanceReportSaga),
    fork(skillMasterSaga),
    fork(resourceApprovalSaga),
    fork(tripmasterSaga),
    fork(PayrollReportsSaga),
    fork(bankMasterSaga),
    fork(evaluationMasterSaga),
    fork(scoreMasterSaga),
  ])
}
